import axiosInstance from '../axiosInterceptor/axiosInstance'

const createOrgClub = async (data) => {
  const { orgId, name, logoDataUri } = data
  const response = await axiosInstance.post(`v1/orgs/${orgId}/clubs`, {
    orgId,
    name,
    logoDataUri,
  })
  return response?.data
}

export default createOrgClub
